export function normalizeIds<T>(value: T): void {
  if (Array.isArray(value)) {
    for (let i = 0; i < value.length; i++) {
      normalizeIds(value[i])
    }
    return
  }

  if (value !== null && typeof value === 'object') {
    for (const [key, val] of Object.entries(value)) {
      if (typeof val === 'string' && /id/i.test(key) && !Number.isNaN(Number(val))) {
        ;(value as any)[key] = Number(val)
      } else {
        normalizeIds(val)
      }
    }
    return
  }
}
